(() => {
  const mobile = matchMedia('(max-width:749px)');
  let state;
  const arrange = () => {
    const editorial = document.querySelector('.pk-dzi-integrated');
    if (!editorial) return;
    if (!state || state.editorial !== editorial) {
      const selectors = ['.pk-dzi-merchants', '.pk-dzi-edit__copy', '.pk-dzi-experience', '.pk-dzi-film', '.pk-dzi-foundation', '.pk-dzi-culture', '[data-pk-buyer-showcase]', 'section#customer-story'];
      const nodes = [...new Set(selectors.flatMap(selector => [...document.querySelectorAll(selector)]))];
      const stack = document.createElement('div');
      stack.className = 'pk-mobile-detail-stack pk-dzi-edit pk-dzi-integrated';
      editorial.after(stack);
      state = { editorial, stack, entries: nodes.map(node => {
        const anchor = document.createComment('pk-mobile-layout-return');
        node.before(anchor);
        return { node, anchor };
      }) };
    }
    if (mobile.matches) {
      state.entries.forEach(({ node }) => state.stack.append(node));
    } else {
      document.querySelectorAll('.pk-mobile-related__dialog[open]').forEach(dialog => dialog.close());
      state.entries.forEach(({ node, anchor }) => {
        if (node.parentElement === state.stack && anchor.isConnected) anchor.after(node);
      });
    }
  };
  const boot = () => requestAnimationFrame(() => { arrange(); document.dispatchEvent(new Event('pk:mobile-arranged')); });
  const editorialScript = document.querySelector('script[src*="/pk-dzi-editorial.js"]');
  const afterEditorial = () => {
    if (document.querySelector('.pk-dzi-integrated')?.dataset.desktopAligned === 'true') boot();
  };
  editorialScript?.addEventListener('load', boot, { once: true });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', afterEditorial, { once: true });
  else afterEditorial();
  if (document.readyState === 'complete') boot();
  else window.addEventListener('load', boot, { once: true });
  mobile.addEventListener('change', boot);
  document.addEventListener('shopify:section:load', boot);
  document.addEventListener('click', event => {
    const open = event.target.closest('[data-pk-related-open]');
    if (open) {
      const dialog = document.getElementById(open.dataset.pkRelatedOpen);
      if (dialog && !dialog.open) dialog.showModal();
    }
    const close = event.target.closest('[data-pk-related-close]');
    if (close) close.closest('dialog').close();
    if (event.target.matches('.pk-mobile-related__dialog')) {
      const rect = event.target.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) event.target.close();
    }
  });
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, () => document.querySelectorAll('.pk-mobile-related__dialog[open]').forEach(dialog => dialog.close()));
  }
})();

(() => {
  const mobile = matchMedia('(max-width:749px)');
  const foldStates = new Map();
  const enhance = () => {
    document.querySelectorAll('.pk-mobile-related__grid:not([data-ranked])').forEach(grid => {
      grid.dataset.ranked = 'true';
      [...grid.children].sort((a,b) => Number(b.dataset.pkRank || 0) - Number(a.dataset.pkRank || 0)).forEach(item => grid.append(item));
    });
    document.querySelectorAll('.pk-dzi-edit__copy:not([data-mobile-reading])').forEach(copy => {
      if (document.querySelector('.pk-dzi-integrated')?.dataset.desktopAligned !== 'true') return;
      copy.dataset.mobileReading = 'true';
      const lead = [...copy.querySelectorAll('p')].find(p => !p.classList.contains('pk-dzi-edit__eyebrow') && p.textContent.trim() && !p.closest('details,[data-pk-buyer-showcase],#customer-story'));
      if (!lead) return;
      const rest = [];
      let node = lead.nextSibling;
      while (node) {
        if (node.nodeType === 1 && node.matches('.pk-dzi-care,.pk-dzi-style-gallery,[data-pk-buyer-showcase],#customer-story')) break;
        rest.push(node);
        node = node.nextSibling;
      }
      if (rest.some(node => node.textContent.trim() || node.nodeType === 1)) {
        const fold = document.createElement('details');
        fold.className = 'pk-mobile-reading';
        const summary = document.createElement('summary');
        summary.textContent = 'Read more';
        fold.append(summary);
        lead.after(fold);
        fold.append(...rest);
        fold.addEventListener('toggle', () => { summary.textContent = fold.open ? 'Show less' : 'Read more'; });
      }
    });
    document.querySelectorAll('.pk-mobile-reading,.pk-dzi-edit__copy .pk-dzi-care').forEach(fold => {
      if (!foldStates.has(fold)) foldStates.set(fold, {desktop:fold.classList.contains('pk-mobile-reading') || fold.open,mobile:false,previous:undefined});
      const state = foldStates.get(fold);
      if (state.previous === mobile.matches) return;
      if (state.previous !== undefined) state[state.previous ? 'mobile' : 'desktop'] = fold.open;
      fold.open = mobile.matches ? state.mobile : state.desktop;
      state.previous = mobile.matches;
    });
    const floater = document.querySelector('.pk-opening-gift-float--product-page');
    if (floater) {
      const hint = floater.querySelector('.pk-karma-float-v2__copy small');
      if (hint) hint.textContent = '5 benefits · Drag to move';
      const toolbar = floater.querySelector('[data-pk-float-drag]');
      if (toolbar) {
        toolbar.tabIndex = 0;
        toolbar.setAttribute('aria-label', 'Move Karma benefits with arrow keys');
        const label = toolbar.querySelector('span');
        if (label) label.textContent = 'KARMA BENEFITS · DRAG TO MOVE';
      }
    }
  };
  let ticking = false;
  const header = () => {
    ticking = false;
    if (!mobile.matches) document.body.classList.remove('pk-product-scrolled');
    else if (scrollY > 180) document.body.classList.add('pk-product-scrolled');
    else if (scrollY < 70) document.body.classList.remove('pk-product-scrolled');
  };
  window.addEventListener('scroll', () => { if (!ticking) { ticking = true; requestAnimationFrame(header); } }, {passive:true});
  const boot = () => requestAnimationFrame(() => { enhance(); header(); });
  window.addEventListener('load', boot, {once:true});
  document.addEventListener('pk:mobile-arranged', boot);
  document.addEventListener('shopify:section:load', boot);
  mobile.addEventListener('change', boot);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, {once:true});
  else boot();
})();
